<template>
	<img class="ornement" :src="source" :alt="alt" :class="position" />
</template>

<script>
export default {
	name: 'OrnementDecoration',
	props: {
		source: { type: String, required: true, default: 'placeholder' },
		alt: { type: String, required: true, default: 'image' },
		position: { type: String, required: true, default: 'placeholder' },
	},
};
</script>

<style></style>
